import { render, staticRenderFns } from "./AdminUserCreate.vue?vue&type=template&id=5fc1d56c&"
import script from "./AdminUserCreate.vue?vue&type=script&lang=js&"
export * from "./AdminUserCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports